module.exports = __webpack_public_path__ + "static/media/handmob.cbdc68ae.png";